import { Model } from '@hatiolab/things-scene'

export interface PalletItem {
  type: string
  description: string
  icon: HTMLImageElement
  group: string | string[]
  model: Model
}

export interface Pallet {
  name: string
  templates: PalletItem[]
}

export type ComponentTemplate = {
  type: string
  description: string
  group:
    | 'line'
    | 'shape'
    | 'textAndMedia'
    | 'chartAndGauge'
    | 'table'
    | 'container'
    | 'dataSource'
    | 'IoT'
    | '3D'
    | 'warehouse'
    | 'form'
    | 'etc'
    | string
  icon: any
  model: Model
}

export type ComponentGroup = {
  name: string
  description: string
  icon: string
  templates: ComponentTemplate[]
}

export type Board = {
  id?: string
  name?: string
  description?: string
  model?: any
  groupId?: string
  thumbnail?: string
}

export type BoardGroup = {
  id?: string
  name?: string
  description?: string
}

export type PlayGroup = {
  id?: string
  name?: string
  description?: string
}
